import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { SessionService, User } from '@app/shared/service/session.service';
import { Router, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs';
import { Customer } from '@app/shared/customer';
import { map, filter } from 'rxjs/operators';
import { Permissions } from '@app/shared/models/enums/permissions';
import { StorefrontBasic } from 'src/app/admin/service/queries/storefront-basic.fragment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  activeLinkSet$: Observable<TemplateRef<any>>;
  customer$: Observable<Customer>;
  activeUser$: Observable<User>;
  activeStorefront$: Observable<StorefrontBasic>;
  permissions = Permissions;
  @ViewChild('customerLinks') customerLinks: TemplateRef<any>;
  @ViewChild('storefrontLinks') storefrontLinks: TemplateRef<any>;

  constructor(
    private sessionService: SessionService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.customer$ = this.sessionService.user$.pipe(map(user => user && user.customer));
    this.activeUser$ = this.sessionService.user$;
    this.activeStorefront$ = this.sessionService.storefront$;
    this.activeLinkSet$ = this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      map(e => e as NavigationEnd),
      map(e => {
        const destination = e.urlAfterRedirects;
        const onCustomerPage = ['orders', 'place-order', 'subscriptions', 'customer']
          .some(path => destination.indexOf(path) >= 0);
        if (onCustomerPage && destination.indexOf('storefront') < 0) {
          return this.customerLinks;
        } else if (destination.indexOf('storefront') >= 0) {
          return this.storefrontLinks;
        }
        return null;
      })
    );
  }
}
